import { getLocation } from 'hooks/useHistory'

// List of non almanac emails to enable feature flags for
const BETA_TESTERS = [
  'jchrishu@amazon.com',
  'tpmelching@gmail.com',
  'taylor+signuptest@almanac.io',
  'taylor+signuptesthome@almanac.io',
  'farhan.ck@bigbinary.com',
]

const DEMO_ALMANAC_ACCOUNTS = ['michaelscott', 'dwight']

export const isAlmanacEmail = (email: string) => email.endsWith('@almanac.io') || email.endsWith('@blaze.ai')

const isAlmanacDemoAccount = (email: string) => {
  return DEMO_ALMANAC_ACCOUNTS.find((account) => email.startsWith(`${account}@`) || email.startsWith(`${account}+`))
}

const isBetaTester = (email: string) => BETA_TESTERS.includes(email)

export enum USERS {
  betaTesters = 'betaTesters',
  withAlmanacEmail = 'withAlmanacEmail',
  withAlmanacEmailNoDemo = 'withAlmanacEmailNoDemo',
  withAlmanacEmailAndBetaTesters = 'withAlmanacEmailAndBetaTesters',
}

/**
 * Checks if the auth user is in one of the given groups. For the hook version, look at useFeatureFlagUserGroup().
 *
 * @param {enum} userGroup User Group to check if user is within group
 * @param {email} email Email of the auth user
 * @returns {boolean} True if user is within group, false if not
 */
export const checkFeatureFlagUserGroup = (userGroups: string[], email: string | undefined): boolean => {
  if (getLocation().search.includes('cypress=true')) return true
  if (email == null) return false

  let show = false

  for (const userGroup of userGroups) {
    if (show) break

    if (userGroup === USERS.withAlmanacEmail) {
      show = isAlmanacEmail(email)
    } else if (userGroup === USERS.withAlmanacEmailNoDemo) {
      show = isAlmanacEmail(email) && !isAlmanacDemoAccount(email)
    } else if (userGroup === USERS.betaTesters) {
      show = isBetaTester(email)
    } else if (userGroup === USERS.withAlmanacEmailAndBetaTesters) {
      show = isAlmanacEmail(email) || isBetaTester(email)
    }
  }
  return show
}
